export default class Role {
  id: number = 0
  name: string = ''
  nameExtern: string = ''
  short: string = ''
  visibleextern: boolean = false
}
